import { Configuration, PopupRequest } from "@azure/msal-browser";

export const msalConfig: Configuration = {
    auth: {
        clientId: "6ee7be3b-700b-4195-97f0-a72595045d15",
        authority: "https://login.microsoftonline.com/a0f7e121-ca5f-4ba9-b64a-82221790d245",
        redirectUri: process.env.REACT_APP_LINNAE_URL
    },
    system: {
        allowNativeBroker: false // Disables WAM Broker
    }
};

export const loginRequest: PopupRequest = {
    scopes: ["api://afdcc88c-648b-46fa-9ad8-347300df746f/access"]
};

export const profileRequest: PopupRequest = {
    scopes: ["User.Read"]
};